import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ImportRequest } from '@peles/shared';
import * as dataImportApi from '../api/data-import';

export function useParseExcel() {
  return useMutation({
    mutationFn: (file: File) => dataImportApi.parseExcelFile(file),
  });
}

export function useParseWord() {
  return useMutation({
    mutationFn: (file: File) => dataImportApi.parseWordFile(file),
  });
}

export function useExecuteImport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ImportRequest) => dataImportApi.executeImport(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
      queryClient.invalidateQueries({ queryKey: ['expenses'] });
    },
  });
}
